import { useEffect, useState } from 'react';
import api from "../services/api";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";  // Importar la biblioteca xlsx

const GenerarInforme = () => {
  const [patologias, setPatologias] = useState([]);
  const [patologiaSeleccionada, setPatologiaSeleccionada] = useState(0);
  const [paises, setPaises] = useState([]);
  const [paisSeleccionado, setPaisSeleccionado] = useState(0);
  const [informeGenerado, setInformeGenerado] = useState(null);

  useEffect(() => {
    GetPatologias();
    GetPaises();
  }, []);

  const GetPatologias = async () => {
    try {
      const response = await api.get(`/getPatologias`);
      setPatologias(response.data);
    } catch (error) {
      console.error("Error al obtener las patologías:", error);
    }
  };

  const GetPaises = async () => {
    try {
      const response = await api.get(`/getPaises`);
      setPaises(response.data);
    } catch (error) {
      console.error("Error al obtener los países:", error);
    }
  };

  const generarInforme = async () => {
    try {
      const response = await api.get(`/generarInforme/${patologiaSeleccionada}/${paisSeleccionado}`);
      const informe = response.data.data[0]; // Obtener el informe generado
      setInformeGenerado(informe); // Guardar el informe generado en el estado
      console.log("Informe generado:", JSON.stringify(informe, null, 1));
    } catch (error) {
      console.error("Error al generar el informe:", error);
    }
  };

  // Función para imprimir el informe generado
  const imprimirInforme = () => {
    if (!informeGenerado) {
      console.log("No hay informe generado para imprimir.");
      return;
    }

    const printWindow = window.open('', '', 'width=800,height=600');
    const contenido = `
            <h3>Informe Generado</h3>
            <p>
                En el país ${informeGenerado.nombrePais}, se han registrado ${informeGenerado.totalCasos || 0} casos de la patología ${informeGenerado.nombrePatologia}.
                Además, se han identificado ${informeGenerado.totalContactos || 0} contactos relacionados con estos casos.
                Con estos registros, suman ${informeGenerado.totalCasos || 0} positivos en el municipio.
                El ${new Date().toLocaleString()}, se realizó vigilancia y seguimiento a ${informeGenerado.totalContactos || 0} nuevos contactos estrechos de casos confirmados.
                En total, se ha realizado la vigilancia y seguimiento a ${informeGenerado.totalContactos || 0} contactos de casos confirmados.
            </p>
        `;
    printWindow.document.write(<html><head><title>Informe Generado</title></head><body>${contenido}</body></html>);
    printWindow.document.close();
    printWindow.print();
  };

  const generarPDF = () => {
    if (!informeGenerado) {
      console.log("No hay informe generado para exportar.");
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(9);

    const textoPDF = `
            En el país ${informeGenerado.nombrePais}, se han registrado ${informeGenerado.totalCasos || 0} casos de la patología ${informeGenerado.nombrePatologia}.
            Además, se han identificado ${informeGenerado.totalContactos || 0} contactos relacionados con estos casos.
            Con estos registros, suman ${informeGenerado.totalCasos || 0} positivos en el municipio.
            El ${new Date().toLocaleString()}, se realizó vigilancia y seguimiento a ${informeGenerado.totalContactos || 0} nuevos contactos estrechos de casos confirmados.
            En total, se ha realizado la vigilancia y seguimiento a ${informeGenerado.totalContactos || 0} contactos de casos confirmados.
        `;

    doc.text(textoPDF, 10, 10);
    doc.save("informe.pdf");
  };

  // Nueva función para exportar a Excel
  const generarExcel = () => {
    if (!informeGenerado) {
      console.log("No hay informe generado para exportar.");
      return;
    }

    // Crear un libro de trabajo y una hoja de cálculo
    const workbook = XLSX.utils.book_new();
    const worksheetData = [
      ["Campo", "Valor"],
      ["País", informeGenerado.nombrePais],
      ["Patología", informeGenerado.nombrePatologia],
      ["Total de Casos", informeGenerado.totalCasos || 0],
      ["Total de Contactos", informeGenerado.totalContactos || 0],
      ["Fecha de Informe", new Date().toLocaleString()]
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Añadir la hoja de cálculo al libro de trabajo
    XLSX.utils.book_append_sheet(workbook, worksheet, "Informe");

    // Generar y descargar el archivo Excel
    XLSX.writeFile(workbook, "informe.xlsx");
  };

  return (
    <div style={styles.container}>
      <div style={styles.formGroup}>
        <div style={styles.inputGroup}>
          <h2>Generar Informe</h2>
          <label style={styles.label}>Patolog&iacute;a:</label>
          <select
            id="patologias"
            value={patologiaSeleccionada}
            onChange={(e) => setPatologiaSeleccionada(e.target.value)}
            style={styles.select}
          >
            <option value="0">Seleccionar patolog&iacute;a</option>
            {patologias.map((patologia) => (
              <option key={patologia.IdPatologia} value={patologia.IdPatologia}>
                {patologia.Nombre}
              </option>
            ))}
          </select>
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>Pa&iacute;s:</label>
          <select
            id="paises"
            value={paisSeleccionado}
            onChange={(e) => setPaisSeleccionado(e.target.value)}
            style={styles.select}
          >
            <option value="0">Seleccionar pa&iacute;s</option>
            {paises.map((pais) => (
              <option key={pais.IdPais} value={pais.IdPais}>
                {pais.Nombre}
              </option>
            ))}
          </select>
        </div>
      </div>

      <button onClick={generarInforme} style={styles.button}>Generar Informe</button>

      {informeGenerado && (
        <>
          <div style={styles.informesContainer}>
            <h3 style={styles.informesTitle}>Informe Generado:</h3>
            <div style={styles.informe}>
              <label style={styles.informeText}>
                En el país {informeGenerado.nombrePais}, se han registrado {informeGenerado.totalCasos || 0} casos de la patología {informeGenerado.nombrePatologia}.
                Además, se han identificado {informeGenerado.totalContactos || 0} contactos relacionados con estos casos.
                <br />
                Fecha de creación: {new Date().toLocaleString()}
              </label>
            </div>
          </div>

          {/* Botones para descargar el informe en PDF, Excel e imprimir */}
          <button onClick={generarPDF} style={styles.button}>Descargar Informe como PDF</button>
          <button onClick={generarExcel} style={styles.button}>Descargar Informe como Excel</button>
          <button onClick={imprimirInforme} style={styles.button}>Imprimir Informe</button> {/* Botón para imprimir */}
        </>
      )}

      <br />
      <div style={styles.verificacion}>
        Verificación:
        <br />
        ID Pa&iacute;s seleccionado: {paisSeleccionado}
        <br />
        ID Patolog&iacute;a seleccionada: {patologiaSeleccionada}
        <br />
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    margin: '20px',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  formGroup: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '20px',
  },
  inputGroup: {
    flex: '1',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: 'bold',
  },
  select: {
    width: '100%',
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  button: {
    display: 'inline-block',
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#007bff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: '10px',
  },
  informesContainer: {
    marginTop: '20px',
  },
  informesTitle: {
    fontSize: '18px',
    marginBottom: '10px',
  },
  informe: {
    backgroundColor: '#e9ecef',
    padding: '10px',
    borderRadius: '8px',
  },
  informeText: {
    fontSize: '16px',
    lineHeight: '1.6',
  },
  verificacion: {
    marginTop: '20px',
    fontSize: '14px',
    color: '#555',
  },
};

export default GenerarInforme;